import { createUseStyles } from "$utils/createUseStyles";
import { theme } from "$utils/theme/bataillog";

export const useStyles = createUseStyles(() => ({
  title: {
    margin: 0,
    marginLeft: 5,
  },
  subtitle: {
    fontWeight: "bold",
  },
  contentStep3: {
    "&.hidden": {
      display: "none",
    },
    "&.show": {
      display: "block",
    },
  },
  contentStep3Title: {
    marginBottom: 15,
  },
  contentStep3Content: {
    "& .MuiInputBase-root.Mui-disabled": {
      background: theme.color.gray2,
    },
    // Only hide radio buttons in components with the hide-radio-circles class
    "&.hide-radio-circles": {
      "& input[type='radio']": {
        display: "none",
      },
      "& .MuiRadio-root": {
        display: "none",
      },
      "& .MuiFormControlLabel-root .MuiRadio-root": {
        display: "none",
      },
    },
  },
  divider: {
    margin: "15px 0 !important",
    display: "block",
  },
  flex: {
    display: "flex",
    flex: 1,
  },
  errorText: {
    color: `${theme.color.red} !important`,
  },
  row: {
    marginBottom: 12,
  },
  gap: {
    gap: theme.spacing(2),
  },
  dialogContent: {
    textAlign: "center",
  },
}));
